import { render } from "./InternalLBAssignVmForm.vue?vue&type=template&id=4bd6cdd8&scoped=true"
import script from "./InternalLBAssignVmForm.vue?vue&type=script&lang=js"
export * from "./InternalLBAssignVmForm.vue?vue&type=script&lang=js"

import "./InternalLBAssignVmForm.vue?vue&type=style&index=0&id=4bd6cdd8&lang=scss&scoped=true"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd6cdd8"]])

export default __exports__